export class PasswordResetBody {
    constructor(email, code, password) {
        this.email = email;
        this.code = code;
        this.password = password;
    }

}
